
    import { Options, Vue } from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import $ from "jquery";
    import CardRh from "@/components/cards/ManzaCard.vue";
    import SiteUtils from "@/assets/ts/aplicacao/site";
    import KDataTable from "@/components/datatable/newdatatable.vue";
    import QtsPdfService from "@/service/v10/sigap/QtsPdfService";

    @Options({
        name: "QtsPdf",
        components: { CardRh, KDataTable },
    })
    export default class QtsPdf extends Vue {
        @Prop() readonly matricula!: any;

        public turmaId: any = null;
        public processando = false;
        public reloadDatatable = false;
        public config: any = null;
        public service: any = new QtsPdfService();
        public dataFiltro = '';

        public refreshTable() {
            setTimeout(() => {
                this.reloadDatatable = !this.reloadDatatable;
            }, 300);
        }

        public apertouEnter(e) {
            if (e.key === 'Enter' || e.keyCode === 13) {
                this.refreshTable();
            }
        }
 
        created() {
            this.turmaId = this.matricula.turmaId;
            this.config = { ajax: {}, columns: [], columnDefs: [], order: [] };
            this.config.ajax = {
                url: this.service.getApiUrl() + '/Matricula/' + this.matricula.id,
                data: (d) => {
                    const dados = {
                        Skip: d.start,
                        Take: d.length,
                        turmaId: this.turmaId,
                        data: this.dataFiltro,
                        search: d.search.value,
                    };
                    return dados;
                }
            };

            this.config.columns = [
                { data: 'id', name: 'id' },
                { data: 'nome', name: 'nome' },
                { data: 'inicio', name: 'inicio' },
                { data: 'fim', name: 'fim' },
                { data: 'updatedAt', name: 'updatedAt' },
                { data: 'status.nome', name: 'status.nome' },
            ];

            this.config.columnDefs = [
                {
                    targets: 2,
                    render: (row) => {
                        return SiteUtils.formatData(row);
                    }
                },
                {
                    targets: 3,
                    render: (row) => {
                        return SiteUtils.formatData(row);
                    }
                },
                {
                    targets: 4,
                    render: (row) => {
                        return SiteUtils.formatDataHora(row);
                    }
                },
            ];

            this.config.columns.push({ data: 'id', name: 'id', orderable: false, searchable: false, class: 'text-center' });
            this.config.columnDefs.push({
                targets: 6,
                render: (row, type, val) => {
                    let texto = '';
                    let buttom = '';
                    for (const key in val) {
                        buttom = buttom + ' data-' + key + '="' + val[key] + '"';
                    }
                    texto = texto + '<button class="btn btn-pmes-primary btn-sm" btn-link ' + buttom + ' title="Link"><i class="fa fa-link"></i></button>';
                    return texto;
                },
            });
        }

        public tableatualizada() {
            $('[btn-link]').click((btn) => {
                const id = $(btn.currentTarget).data('id');
                this.getModelLink(id);
            });
        }

        protected getModelLink(id) {
            this.processando = true;
            setTimeout(() => {
                this.service.getModelLink(id)
                    .then(response => {
                        this.processando = false;
                        window.open(response, '_blank');
                    })
                    .catch(() => {
                        this.processando = false;
                    });
            }, 1);
        }
    }
